var map = {
	"./car.png": "19fe",
	"./clothing.png": "7ffe",
	"./donation.png": "691a",
	"./food.png": "1853",
	"./leisure.png": "0bb8",
	"./other.png": "4abe",
	"./pets.png": "dacf",
	"./pharma.png": "e3e1",
	"./public-transportation.png": "5228",
	"./super.png": "7d32",
	"./tourism.png": "8abc",
	"./tracking-categories-no-selection.svg": "96e9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1f38";